export default __webpack_public_path__ + "static/media/Question.8da111af.svg";